/**
 * Front-page module slugs that are also available on the profession landing page.
 *
 * For these slugs:
 *  - The conductor lets the editor reorder, hide, and show them on the profession page.
 *  - The conductor does NOT let the editor change their content — content is
 *    inherited at render time from the active front-page version.
 *
 * Add slugs as needed. The slug must exist in `config/frontPageModules.js`.
 *
 * Example:
 *   ["partner-logos", "reviews", "cta-banner"]
 */
export const SHARED_FRONT_PAGE_MODULE_SLUGS = new Set([
  "partner-logos",
  "reviews",
  // NOTE: "faq" intentionally removed. The profession page now has its own
  // editable FAQ module ("profession-faq", see config/professionPageModules.js)
  // instead of inheriting the front-page FAQ content.
  "blog",
]);
